import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ASHero from './components/ASHero';
import ASHow from './components/ASHow';
import ASIntegrations from './components/ASIntegrations';
import ASPricing from './components/ASPricing';
import ASCTA from './components/ASCTA';

export default function AiSales() {
  return (
    <main>
      <Navbar />
      <ASHero />
      <ASHow />
      <ASIntegrations />
      <ASPricing />
      <ASCTA />
      <Footer />
    </main>
  );
}